import React from "react";
import "./BeneficioIcono.css";

interface BeneficioIconoProps {
  texto: string;
  icono: string;
  descripcion?: string;
}

export default function BeneficioIcono({ texto, icono, descripcion }: BeneficioIconoProps) {
  return (
    <div className="beneficio-icono-container">
      <div className="beneficio-circulo">
        <img
          src={`/icons/${icono}`}
          alt={descripcion || ""} 
          className="beneficio-icono-img"
          aria-hidden={!descripcion}
        />
      </div>
      <p className="beneficio-texto">{texto}</p>
    </div>
  );
}
